<template>
  <v-container class="py-12">
    <v-row>
      <v-col :cols="12">
        <div class="title-container">
          <div class="title-block">
            <span id="title" class="page-title">Imagens DSD</span>
            <v-breadcrumbs
              class="app-breadcrumb"
              divider="›"
              :items="[
                { text: 'Homepage', disabled: false, to: '/home', exact: true },
                { text: 'DSD', disabled: false, to: '/dsd', exact: true },
                { text: 'Imagens', disabled: true, exact: true },
              ]"
            ></v-breadcrumbs>
          </div>
          <div class="button-group" style="padding-right: 16px;">
            <v-btn type="button" color="primary" elevation="0" :loading="loadingSave" @click="save">{{ editingId ? 'Atualizar' : 'Salvar' }}</v-btn>
            <v-btn type="button" color="primary" outlined elevation="0" @click="$router.push('/dsd')">Voltar</v-btn>
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- Form -->
    <v-row>
      <v-col cols="12">
        <v-card class="form-card">
          <v-card-title>
            {{ editingId ? 'Editar Imagem' : 'Adicionar Nova Imagem' }}
          </v-card-title>
          <v-card-text>
            <v-form ref="assetForm">
              <v-row align="center">
                <v-col cols="12" md="4">
                  <v-text-field
                    label="Nome"
                    v-model="form.name"
                    outlined
                    dense
                    :rules="[v => !!v || 'Campo obrigatório']"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="5">
                  <v-file-input
                    label="Arquivo de Imagem"
                    v-model="form.file"
                    outlined
                    dense
                    accept="image/*"
                    prepend-icon="mdi-image"
                    :rules="editingId ? [] : [v => !!v || 'Selecione uma imagem']"
                    hide-details="auto"
                    show-size
                    clearable
                  >
                    <template #append-outer>
                      <v-tooltip bottom>
                        <template #activator="{ on }">
                          <v-icon v-on="on" color="grey">mdi-help-circle-outline</v-icon>
                        </template>
                        <span>Insira um asset sem fundo</span>
                      </v-tooltip>
                    </template>
                  </v-file-input>
                </v-col>

                <v-col v-if="editingId" cols="12" md="3" class="d-flex align-center pb-10">
                  <v-btn color="grey lighten-1" dark elevation="0" @click="cancelEdit">
                    Cancelar
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Preview da imagem em edição -->
              <v-row v-if="editingId && currentImageUrl">
                <v-col cols="12" md="4">
                  <div class="caption grey--text mb-1">Imagem atual:</div>
                  <img :src="currentImageUrl" style="max-height: 80px; border-radius: 4px; border: 1px solid #ddd;" />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-divider class="my-6"></v-divider>

    <!-- Tabela -->
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="assets"
              :loading="loadingTable"
              no-data-text="Nenhuma imagem cadastrada"
              loading-text="Carregando..."
              class="app-table hover-table"
            >
              <template v-slot:[`item.preview`]="{ item }">
                <img
                  :src="imageUrl(item.resourceId)"
                  style="height: 48px; width: 48px; object-fit: contain; border-radius: 4px; border: 1px solid #eee;"
                />
              </template>

              <template v-slot:[`item.name`]="{ item }">
                {{ item.name }}
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-row align="center">
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-icon v-on="on" @click="editItem(item)" size="large">mdi-pencil-outline</v-icon>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-icon v-on="on" @click="deleteItem(item)" size="large" class="ml-1">mdi-delete</v-icon>
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>
                </v-row>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-overlay :value="loadingPage">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "DsdAssets",

  data: () => ({
    form: {
      name: "",
      file: null,
    },
    editingId: null,
    currentImageUrl: null,

    assets: [],
    headers: [
      { text: "Imagem", value: "preview", sortable: false, width: 80 },
      { text: "Nome", value: "name" },
      { text: "Ações", value: "actions", sortable: false, width: 100 },
    ],

    loadingPage: false,
    loadingSave: false,
    loadingTable: false,
  }),

  created() {
    this.load();
  },

  methods: {
    imageUrl(resourceId) {
      if (!resourceId) return "";
      const base = axios.defaults.baseURL || "";
      return `${base}/resources/${resourceId}`;
    },

    async load() {
      this.loadingTable = true;
      try {
        const response = await axios.get("/dsd-assets");
        this.assets = (response.data.data || response.data || []).map(this.normalizeAsset);
      } catch (error) {
        console.error("Erro ao carregar imagens:", error);
        this.$dialog.notify.error("Erro ao carregar imagens.", { position: "top-right", timeout: 5000 });
      } finally {
        this.loadingTable = false;
      }
    },

    async save() {
      if (!this.$refs.assetForm.validate()) return;

      this.loadingSave = true;
      try {
        let resourceId = this.editingId ? this.assets.find(a => a.id === this.editingId)?.resourceId : null;

        if (this.form.file) {
          const formData = new FormData();
          formData.append("file", this.form.file);
          const uploadRes = await axios.post("/resources", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
          resourceId = uploadRes.data.data.id;
        }

        const payload = { name: this.form.name, resourceId };

        if (this.editingId) {
          await axios.patch(`/dsd-assets/${this.editingId}`, payload);
          this.$dialog.notify.success("Imagem atualizada com sucesso!", { position: "top-right", timeout: 3000 });
        } else {
          await axios.post("/dsd-assets", payload);
          this.$dialog.notify.success("Imagem adicionada com sucesso!", { position: "top-right", timeout: 3000 });
        }

        this.cancelEdit();
        await this.load();
      } catch (error) {
        console.error("Erro ao salvar imagem:", error);
        this.$dialog.notify.error("Erro ao salvar imagem.", { position: "top-right", timeout: 5000 });
      } finally {
        this.loadingSave = false;
      }
    },

    editItem(item) {
      this.editingId = item.id;
      this.form.name = item.name;
      this.form.file = null;
      this.currentImageUrl = this.imageUrl(item.resourceId);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    normalizeAsset(item) {
      return {
        ...item,
        resourceId: item.resource?.id || item.resourceId || item.resource_id || null,
      };
    },

    cancelEdit() {
      this.editingId = null;
      this.currentImageUrl = null;
      this.form.name = "";
      this.form.file = null;
      this.$refs.assetForm?.resetValidation();
    },

    async deleteItem(item) {
      const confirm = await this.$dialog.confirm({
        text: `Tem certeza que deseja excluir "${item.name}"?`,
        title: "Confirmar Exclusão",
        actions: {
          false: "Cancelar",
          true: { text: "Excluir", color: "error" },
        },
      });

      if (!confirm) return;

      try {
        this.loadingTable = true;
        await axios.delete(`/dsd-assets/${item.id}`);
        this.$dialog.notify.success("Imagem excluída com sucesso!", { position: "top-right", timeout: 3000 });
        await this.load();
      } catch (error) {
        console.error("Erro ao excluir imagem:", error);
        this.$dialog.notify.error("Erro ao excluir imagem.", { position: "top-right", timeout: 5000 });
      } finally {
        this.loadingTable = false;
      }
    },
  },
};
</script>
